import classNames from 'classnames';
import { FC, memo } from 'react';
import Example from '../Example';

interface iFamilyProps {
  name: string;
  family: string;
  active?: boolean;
  onSelect: (family: string) => void;
  example?: string;
}

const Family: FC<iFamilyProps> = memo(({ name, family, onSelect, active, example }) => {
  const _handleSelect = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(family);
  };

  return (
    <div className={classNames('font-family', active && 'active')} onMouseDown={_handleSelect}>
      <span style={{ fontFamily: `'${family.includes('ttf') ? name : family}', serif` }}>{name}</span>
      {example && <Example content={example} />}
    </div>
  );
});

export default Family;
